// Version checking utility for PWA force updates
const CURRENT_VERSION = '1.5.11';

export const checkForUpdates = async () => {
  // Skip version checking in development
  if (process.env.NODE_ENV === 'development') {
    return { updateAvailable: false };
  }
  
  try {
    // Check server version
    const response = await fetch('/manifest.json?' + Date.now(), { 
      cache: 'no-cache' 
    });
    const manifest = await response.json();
    
    console.log('Current version:', CURRENT_VERSION);
    console.log('Server version:', manifest.version);
    
    if (manifest.version !== CURRENT_VERSION) {
      console.log('Version mismatch detected, forcing update...');
      return {
        updateAvailable: true,
        serverVersion: manifest.version,
        currentVersion: CURRENT_VERSION
      };
    }
    
    return { updateAvailable: false };
  } catch (error) {
    console.error('Error checking version:', error);
    return { updateAvailable: false };
  }
};

export const forceReload = async () => {
  console.log('🔥 NUCLEAR UPDATE: Forcing complete PWA refresh...');
  
  try {
    // Step 1: Unregister ALL service workers
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      console.log('Found', registrations.length, 'service worker registrations');
      
      for (let registration of registrations) {
        console.log('Unregistering service worker:', registration.scope);
        await registration.unregister();
      }
    }
    
    // Step 2: Clear ALL caches
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      console.log('Found', cacheNames.length, 'caches to delete');
      
      await Promise.all(
        cacheNames.map(cacheName => {
          console.log('Deleting cache:', cacheName);
          return caches.delete(cacheName);
        })
      );
    }
    
    // Step 3: Clear all storage
    if ('localStorage' in window) {
      console.log('Clearing localStorage...');
      localStorage.clear();
    }
    
    if ('sessionStorage' in window) {
      console.log('Clearing sessionStorage...');
      sessionStorage.clear();
    }
    
    // Step 4: Nuclear reload
    console.log('🚀 All caches and workers cleared, forcing hard reload...');
    
    // Try multiple reload methods
    if (window.location.reload) {
      window.location.reload(true);
    } else {
      window.location.href = window.location.href + '?t=' + Date.now();
    }
    
  } catch (error) {
    console.error('Error during nuclear update:', error);
    // Fallback: just reload anyway
    window.location.reload(true);
  }
};

// Expose global functions for manual testing
window.SuppleDebug = {
  checkVersion: checkForUpdates,
  forceUpdate: forceReload,
  nuclearReload: forceReload
};

export const initVersionCheck = () => {
  // Disabled automatic version checking to prevent reload loops
  console.log('Version checking initialized (manual mode only)');
  
  // Only keep the debug functions available for manual testing
  // Automatic checks are disabled to prevent production reload loops
};